/* eslint-disable no-unreachable */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable radix */
/* eslint-disable no-nested-ternary */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-plusplus */
/* eslint-disable import/order */
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
// material
import {
  Stack,
  Button,
  Container,
  Typography,
  Backdrop,
  CircularProgress,
  Grid,
  Divider,
  LinearProgress,
  IconButton,
  Box,
  MenuItem,
  Menu,
} from '@mui/material';
// components
import { collection, doc, getDoc, getDocs, orderBy, query } from 'firebase/firestore';
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
// mock
import { db } from '../../firebase.config';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { alpha } from '@mui/system';
import { shortNumber } from '../../utils/formatNumber';
import CustomButton from '../../components/CustomButton';
import styled from '@emotion/styled';
import Swipeable from '../crm/component/swiper';
import { Variables } from '../../context/VariableContext';
import CustomTag from '../../components/customTag';
import LucideIcon from '../../components/LucideIcon';

// ----------------------------------------------------------------------
// ----------- for more bouton modal
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 5,
    paddingTop: 10,
    paddingBottom: 10,
    marginTop: theme.spacing(1),
    minWidth: 200,
    color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow: 'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 0.5px, rgba(0, 0, 0, 0.1) 0px 5px 10px -3px, rgba(0, 0, 0, 0.05) 0px 2px 4px -1px',

    '& .MuiMenu-list': {
      padding: 5,
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 15,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
    },
  },
}));

export default function DateList() {
  const { eventID } = useParams();
  // GESTION DE LA MODIFICATION
  const { openDrawer, setOpenDrawer } = Variables();
  const { type, setType } = Variables();
  const [modif, setModif] = useState(false);
  // loading
  const [loading, setLoading] = useState(false);

  const handleToggle = () => {
    setOpen(!open);
  };
  // for change value of globla quota
  const [open, setOpen] = useState(false);
  const [refreh, setRefresh] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    // setModif(false);
    setRefresh((prev) => !prev);
  };

  // take tickets from firebase
  const [event, setEvent] = useState([]);
  const [dates, setDates] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [quotas, setQuotas] = useState([]);
  const [groupDate, setGroup] = useState([]);
  const [itemGroup, setItemGroup] = useState([]);



  const handleTimestamp = (e) => {
    const date = e.toDate();
    const tmp = date.toJSON().split('.');
    const t = tmp[0].split('T');
    return t[0];
  };
  const handleTimestamp1 = (e) => {
    const date = e.toDate();
    const tmp = date.toJSON().split('.');
    const t = tmp[0].split('T');
    return t[1];
  };

  const handleTimestampC1 = (e) => {
    const date = e.toDate();
    return format((new Date(date.toJSON())), 'yyyy-MM-dd', { locale: fr }).toString();
  };

  const handleTimestampC2 = (e) => {
    const date = e.toDate();
    return format((new Date(date.toJSON())), 'HH:mm', { locale: fr }).toString();
  };




  const navigate = useNavigate();
  // recuperation des dates
  useEffect(() => {
    (async () => {
      setTickets([]);
      setDates([]);
      try {
        setLoading(true);
        // event
        const docRef0 = doc(db, 'evenement', eventID);
        const docSnap = await getDoc(docRef0);
        if (docSnap.exists()) {
          setEvent(docSnap.data());
        }
        // recuperation des tickets
        const q1 = query(collection(db, `evenement/${eventID}/tickets`));
        const snapshot1 = await getDocs(q1);
        snapshot1.forEach((d) => {
          setTickets((tickets) => [...tickets, d]);
        });

        // recuperation des dates
        const q = query(collection(db, `evenement/${eventID}/seances`), orderBy('date', 'asc'));
        const snapshot = await getDocs(q);
        const tmpd = [];
        const groups = [];
        const group = [];
        snapshot.forEach((d) => {
          setDates((dates) => [...dates, d]);
          const tmpDate = format(new Date(handleTimestamp(d.data().date)), 'MMMM yyyy', { locale: fr });
          tmpd.push(d.data());
          const found = groups.find((element) => element === tmpDate);
          if (!found) {

            groups.push(tmpDate);
          }
        });


        for (let index = 0; index < groups.length; index++) {
          const tgroup = [];
          snapshot.forEach((d) => {
            const tmpDate = format(new Date(handleTimestamp(d.data().date)), 'MMMM yyyy', { locale: fr });
            if (groups[index] === tmpDate) {
              tgroup.push(d);
            }
          });
          group.push(tgroup);
        }
        setGroup(groups);
        setItemGroup(group);

      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [refreh]);



  const [nom, setNom] = useState('');
  const [debut, setDebut] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(null);
  const today = new Date();
  const today1 = new Date(today.getFullYear(), today.getMonth(), today.getDate(), today.getHours(), today.getMinutes());
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  const handleOpenMenu = (event, index) => {
    setSelectedIndex(index);
    setAnchorEl(event.currentTarget);
    // setOpenMenu(true);
  };
  const handleCloseMenu = (e) => {
    setAnchorEl(null);
    // setOpenMenu(false);
  };

  const manage = () => {
    navigate(`${selectedIndex.id}`)
  }
  const manage1 = (e) => {
    navigate(`${e?.id}`)
  }

  const handleCreateEvent = () => {
    console.log(selectedIndex.data())
    setType(7)
    setOpenDrawer(true)
  };



  return (
    <Page title="Séance">
      <Backdrop sx={{ color: '#ffff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {loading && <LinearProgress />}
      {!loading && event.seanceActive === 1 ? (
        <>
          {!loading && dates.length === 0 ? (
            <Container>

              <Stack spacing={1} sx={{ border: '1px solid #f2f2f2', padding: 5, width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                <Iconify icon="icomoon-free:drawer2" sx={{ width: 30, height: 30 }} />
                <Typography variant="caption">Vous n'avez pas encore de seance</Typography>
                <Typography variant="caption">Cliquer sur <strong>Ajouter des seances</strong> pour créer de nouvelles seances</Typography>
              </Stack>
            </Container>
          ) : (

            <>

              <Box>
                <Stack spacing={4} >
                  {groupDate.map((group, index) => (
                    <Box key={index}>
                      <Stack direction={'row'} spacing={2}>
                        <Typography variant='h5' fontWeight={500}>{group}</Typography>
                        <Typography variant='body2'>({itemGroup[index].length} seance(s))</Typography>
                      </Stack>

                      {
                        /** */
                      }
                      {itemGroup[index].map((item, j) => (

                        <Grid container key={j} paddingY={2} paddingX={2} marginTop={1} sx={{
                          display: 'flex', alignItems: 'center', cursor: 'pointer',
                          border: '2px solid #f2f2f2',
                          borderRadius: '10px',

                        }} >
                          <Grid item xs={12} sm={7} onClick={() => manage1(item)} >
                            <Stack direction='row' spacing={3} alignItems='center'>
                              <Stack justifyContent='center' alignItems='center' sx={{ color: '#5E17EB' }}>
                                <Typography sx={{ textTransform: 'capitalize' }} variant='caption'>{format(new Date(handleTimestampC1(item.data().date)), 'EEE', { locale: fr })}</Typography>
                                <Typography variant='h4' fontWeight={550} sx={{ color: '#5E17EB' }}>{format(new Date(handleTimestampC1(item.data().date)), 'dd')}</Typography>
                              </Stack>
                              <Box sx={{bgcolor:'#f2f2f2', height: 80, width: 1.5}}/>
                              <Stack>
                                <Typography variant='body2'>{item.data().name ? item.data().name : '-'}</Typography>
                                <Stack spacing={0.5} >
                                  <Stack direction={'row'} spacing={1} alignItems={'center'}>
                                    <LucideIcon size={18} name='Clock' />
                                    <Stack direction={'row'} spacing={0.5}>
                                      <Typography variant='body2'>{handleTimestampC2(item.data().date)}</Typography>
                                      <Typography variant='body2'>-</Typography>
                                      <Typography variant='body2'>{handleTimestampC2(item.data().fin)}</Typography>
                                    </Stack>
                                  </Stack>

                                  <Stack direction={'row'} spacing={1}>
                                    {
                                      new Date(handleTimestampC1(item.data().date)) < today1 ?
                                        <CustomTag text={'Passé'} textColor={'#ffbb29'} />
                                        : null
                                    }
                                    {
                                      item.data().status === 0 ?
                                        <CustomTag text={'seance inactive'} type={'error'} />
                                        : item.data().status === 1 ?
                                          <CustomTag text={'seance active'} />
                                          : null
                                    }
                                  </Stack>



                                </Stack>
                              </Stack>
                            </Stack>
                          </Grid>
                          <Grid onClick={() => manage1(item)} item xs={4} sm={2} >
                            <Stack>
                              <Typography variant='body2'>Participants</Typography>
                              <Typography variant='body2'>{item.data().participants > 0 ? item.data().participants : '-'}</Typography>
                            </Stack>

                          </Grid>
                          <Grid onClick={() => manage1(item)} item xs={4} sm={2} >
                            <Typography variant='body2'>{item.data().recette > 0 ? `${shortNumber(item.data().recette)} CFA` : '-'} </Typography>
                          </Grid>


                          <Grid item xs={1} sm={1}>
                            <IconButton key={j} onClick={(e) => handleOpenMenu(e, item)}
                              aria-controls={openMenu ? 'demo-customized-menu' : undefined}
                              aria-haspopup="true"
                              aria-expanded={openMenu ? 'true' : undefined}>
                              <Iconify icon="material-symbols-light:more-vert" />
                            </IconButton>
                            
                          </Grid>
                        </Grid>))}
                      {
                        /** */
                      }
                    </Box>
                  ))}
                </Stack>
              </Box>
              <StyledMenu
                              id="demo-customized-menu"
                              MenuListProps={{
                                'aria-labelledby': 'demo-customized-button',
                              }}
                              anchorEl={anchorEl}
                              open={openMenu}
                              onClose={handleCloseMenu}
                            >

                              <MenuItem onClick={(e) => {
                                handleCloseMenu();
                                manage()
                              }} disableRipple value={0}>
                                <Typography variant='body2'>Gérer</Typography>
                              </MenuItem>
                              <MenuItem onClick={(e) => {
                                handleCloseMenu();
                                handleCreateEvent()
                              }} disableRipple value={3}>
                                <Typography variant='body2'>Modifier</Typography>
                              </MenuItem>
                              <MenuItem
                                onClick={(e) => {
                                  // handleCloseMenu();
                                  // goToSite()
                                }}
                                disableRipple
                                value={1}
                              >
                                <Typography variant='body2'>rendre disponible</Typography>
                              </MenuItem>
                              <MenuItem
                                onClick={(e) => {
                                  // handleCloseMenu();
                                  // handleOpenSup()
                                }}
                                disableRipple
                                value={4}
                              >
                                <Typography variant='body2'>Supprimer</Typography>
                              </MenuItem>

                            </StyledMenu>
              <Swipeable type={type} eventID={eventID} seanceID={selectedIndex?.id} seanceData={selectedIndex?.data()} />
            </>


          )}
        </>
      ) : null}
    </Page>
  );
}
